import { render, staticRenderFns } from "./WeighingCard.vue?vue&type=template&id=45654959&scoped=true&"
import script from "./WeighingCard.vue?vue&type=script&lang=js&"
export * from "./WeighingCard.vue?vue&type=script&lang=js&"
import style0 from "./WeighingCard.vue?vue&type=style&index=0&id=45654959&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45654959",
  null
  
)

export default component.exports